import React from "react";
import PropTypes from "prop-types";
import Selector from "../controls/selector";
import ListaVariables from "../../inumet_js_lib/model/variables/listaVariables";

class SelectorVar extends React.Component {
  render() {
    let options = [];
    if (!this.props.loading && this.props.variables) {
      options = this.props.variables.map((v) => {
          let nombre= v.getNombre(this.props.incluirUnidad);
          if (this.props.labelsMap && this.props.labelsMap[v.id]){
            nombre = this.props.labelsMap[v.id]
          }
        else if (this.props.opcionesVars && this.props.opcionesVars[v.id]){
            nombre = this.props.opcionesVars[v.id].label
            if (this.props.opcionesVars[v.id].sublabel){
                nombre+= "  * "+ this.props.opcionesVars[v.id].sublabel+""
            }
        }

        return { value: v, label: nombre };
      });
    }

    return (
      <Selector
        options={options}
        defaultValueIndex={this.props.defaultValueIndex}
        label={this.props.label ? this.props.label : "Variable"}
        labelStyle={this.props.labelStyle}
        loading={this.props.loading}
        formGroup={this.props.formGroup}
        isClearable={this.props.isClearable}
        mt={this.props.mt}
        mr={this.props.mr}
        mb={this.props.mb}
        ml={this.props.ml}
        onSelect={(e) => {
          if (!e) this.props.onSelect(-1, null);
          else
            this.props.onSelect(
              this.props.variables.indexOf(e.value.id),
              e.value
            );
        }}
        errorText={this.props.errorText}
        isDisabled={this.props.isDisabled}
        placeholder={this.props.placeholder}
        placeholderDisabled={this.props.placeholderDisabled}
        placeholderNoItems={this.props.placeholderNoItems}
      ></Selector>
    );
  }
}

SelectorVar.propTypes = {
  variables: PropTypes.instanceOf(ListaVariables),
  defaultValueIndex: PropTypes.node,
  onSelect: PropTypes.func,
  incluirUnidad: PropTypes.bool,
  loading: PropTypes.bool,
  formGroup: PropTypes.bool,
  labelStyle: PropTypes.object,
  label: PropTypes.string,
  isClearable: PropTypes.bool,
  mt: PropTypes.number,
  mr: PropTypes.number,
  ml: PropTypes.number,
  mb: PropTypes.number,
  errorText: PropTypes.string,
  labelsMap: PropTypes.object,
  isDisabled: PropTypes.bool,
  placeholderDisabled: PropTypes.string,
  placeholder: PropTypes.string,
  placeholderNoItems:PropTypes.string,
  opcionesVars:PropTypes.array,
};

export { SelectorVar as default };
